import { ShareableFile } from '../../selectors/FileLinksSelector';
import { createFileLinksSection } from './create/createFileLinksSection';

const escapeHtml = (text: string): string =>
  text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

interface EmailBody {
  text: string;
  html: string;
}

interface PrepareEmailBodyParams {
  message: string;
  signature?: string;
  fileLinks: ShareableFile[];
}

/**
 * Prepares email body text and HTML with optional file links and signature
 * @param message - User message content
 * @param signature - Optional signature appended between message and file links
 * @param fileLinks - Array of shareable file links to include
 * @returns Email body in both text and HTML formats
 */
export const prepareEmailBody = ({ message, signature, fileLinks }: PrepareEmailBodyParams): EmailBody => {
  const baseText = message || 'Please find the attached form.';
  const baseHtml = message ? escapeHtml(message).replace(/\n/g, '<br/>') : 'Please find the attached form.';

  const signatureText = signature?.trim() ?? '';
  const signatureHtml = signatureText ? escapeHtml(signatureText).replace(/\n/g, '<br/>') : '';

  const textAfterMessage = signatureText ? baseText + '\n\n' + signatureText : baseText;
  const htmlAfterMessage = signatureHtml ? baseHtml + '<br/><br/>' + signatureHtml : baseHtml;

  const linksForEmail = fileLinks.filter(file => file.isShared && file.shareUrl);
  const { html: fileLinksHtml, text: fileLinksText } = createFileLinksSection(linksForEmail);

  const textWithSpacing = textAfterMessage + (fileLinksText ? '\n\n' : '');
  const htmlWithSpacing = htmlAfterMessage + (fileLinksHtml ? '<br/><br/>' : '');

  return {
    text: textWithSpacing + fileLinksText,
    html: htmlWithSpacing + fileLinksHtml
  };
};

